export default {
  data() {
    return {
      leads: [
        {
          id: 1,
          name: "LEADS",
          alias: "brokers"
        }
      ]
    };
  },

  created() {
    if (this.CheckUserPermission([1, 2, 3, 4, 5, 6, 12]))
      this.leads = [
        ...this.leads,
        {
          id: 2,
          name: "USERS",
          alias: "users"
        }
      ];
  }
};
